export const removeParentheses = (text) => {
  if (typeof text !== 'string') {
    return '';
  }

  return text
    .replace(/\([^)]*\)/g, '')
    .trim()
    .replace(/\s+/g, ' ');
};
